$(document).ready(() => {
  // determines from the tracker-container element which template we're using.
  const trackerTemplate = $('#tracker-container').hasClass('standard') ? 'standard' : 'profile';
  const heightLimits = { standard: 450, profile: 350 };
  // this is to store all the items original heights before truncating
  const allItemsHeights = [];
  const $allItems = $('.tracker__body');
  $allItems.each(function() {
    const itemHeight = $(this).prop('scrollHeight');
    allItemsHeights.push(itemHeight);
    // If an item's body height plus 100px is more than the desired truncated height
    // and the item has the truncate-body class, then it will be truncated
    if (itemHeight > (heightLimits[trackerTemplate] + 100) && $(this).hasClass('truncate-body')) {
      $(this).find('.gradient-overlay').show();
      $(this).parent().find('.keep-reading-btn').show();
    } else {
      $(this).removeClass('truncate-max-height');
    }
  });
  $('.keep-reading-btn').click(function() {
    // get the index for the current tracker item in order to get its original height
    const itemIndex = $(this).attr('id');
    $(this).hide();
    const $itemToExpand = $(this).parent().find('.truncate-body');
    const itemOriginalHeight = allItemsHeights[itemIndex];
    $itemToExpand.find('.gradient-overlay').fadeOut();
    $itemToExpand.animate({
      'max-height': itemOriginalHeight,
    }, 200);
    // profile trackers: the updated date is below the body and not included in the original height
    $itemToExpand.css('max-height', '100%');
    // send "keep reading" click events to google analytics
  });
});
